export default __webpack_public_path__ + "static/gearsTactics-white-4dae0b972f375595a80034326a9fd1b7.svg";